































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import users from '@/store/modules/users';
import { RawLocation, Route } from 'vue-router';
import supplyChain from '@/store/modules/supplychains';
import suppliersData from '@/store/modules/suppliers';
import * as _ from 'lodash';
import { Helpers } from '@/tools/helpers';
// import { getIdentityProfile } from '@/store/identity';

@Component({})
export default class HeaderNav extends Vue {
  private menu: boolean = false;
  private showChildMenu: boolean = false;
  private curProject: any | null = null;
  private ecx_logo_image = require('@/assets/EconomX logo - on light bg.svg');
  private currentItem: any = null;
  private currentChild: any = null;
  private projectsList: any = [];
  private loaded: boolean = false;
  private search: string | null = null;
  private dashboardItem = {
    title: 'Dashboard',
    icon: 'fas fa-home',
    link: '/dashboard',
    external: false,
    buyer: true,
    supplier: false,
    current_project: true,
    id: 'home',
  };
  private items: any = [
    {
      title: `${Helpers.projectsLabel}`,
      icon: 'fas fa-th',
      link: null,
      external: false,
      buyer: true,
      supplier: false,
      current_project: false,
      id: 'networks',
      children: [
        {
          title: `Your ${Helpers.projectsLabel.toLowerCase()}`,
          link: `/your-${Helpers.projectsLabel.toLowerCase()}`,
          buyer: true,
          supplier: true,
          current_project: false,
          id: 'your_networks',
        },
        {
          title: `${Helpers.projectLabel} dashboard`,
          link: `/${Helpers.projectLabel.toLowerCase()}-dashboard`,
          buyer: true,
          supplier: true,
          current_project: false,
          id: 'network_dashboard',
        },
        {
          title: 'Market Requests',
          link: `/market-requests`,
          buyer: true,
          supplier: true,
          current_project: false,
          id: 'market_requests',
        },
        {
          title: 'Manage categories',
          link: '/managecategories',
          buyer: true,
          supplier: true,
          current_project: false,
          id: 'manage_categories',
        },
      ],
    },
    {
      title: 'Suppliers',
      icon: 'fas fa-users',
      link: '',
      external: false,
      buyer: true,
      supplier: true,
      current_project: true,
      id: 'suppliers',
      children: [
        {
          title: 'Search suppliers',
          link: '/suppliersearch',
          id: 'supplier_search',
        },
        {
          title: 'Manage suppliers',
          link: '/managesuppliers',
          id: 'manage_suppliers',
        },
      ],
    },
    {
      title: 'Work',
      icon: 'fas fa-search',
      link: null,
      external: false,
      buyer: false,
      supplier: true,
      id: 'work',
      children: [
        {
          title: `${Helpers.projectNetworkLabel}`,
          link: `/${Helpers.projectNetworkLabel.replace(/\s+/g, '-').toLowerCase()}`,
          buyer: true,
          supplier: true,
          current_project: false,
          id: 'supply_networks',
        },
        {
          title: 'Market Requests',
          link: `/${Helpers.projectLabel.toLowerCase()}-market-requests`,
          buyer: true,
          supplier: true,
          current_project: false,
          id: 'work_market_requests',
        },
      ],
    },
    {
      title: 'Surveys',
      icon: 'fas fa-clipboard-list',
      link: '/surveys',
      external: false,
      buyer: true,
      supplier: true,
      current_project: false,
      id: 'surveys',
    },
    {
      title: 'Business',
      icon: 'fas fa-building',
      link: '/businessProfile',
      external: false,
      buyer: true,
      supplier: false,
      current_project: false,
      id: 'business',
    },
    {
      title: 'Account',
      icon: 'fas fa-cog',
      link: null,
      external: false,
      buyer: true,
      supplier: false,
      current_project: false,
      id: 'account',
      children: [
        {
          title: 'Your profile',
          link: '/profile',
          buyer: true,
          supplier: true,
          current_project: false,
          id: 'your_profile',
        },
        {
          title: 'Users',
          link: '/users',
          buyer: true,
          supplier: true,
          current_project: false,
          id: 'users',
        },
        {
          title: 'Billing',
          link: '/billingdetails',
          buyer: true,
          supplier: true,
          current_project: false,
          id: 'billing',
        },
        {
          title: 'Preferences',
          link: '/preferences',
          buyer: true,
          supplier: true,
          current_project: false,
          id: 'preferences',
        },
      ],
    },
    {
      title: 'Messages',
      icon: 'fas fa-envelope',
      link: '/exchange',
      external: false,
      buyer: false,
      supplier: true,
      id: 'messages',
    },
    {
      title: 'Support',
      icon: 'fas fa-life-ring',
      link: 'https://support.economx.com/',
      external: true,
      buyer: false,
      supplier: true,
      id: 'support',
    },
  ];
  private linkReplacePattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

  get identityProfileUrl() {
    return (process.env.VUE_APP_ID_API + "profile").replace(this.linkReplacePattern, 'http://$2')
  }

  get isSmallScreen() {
    return window.innerWidth > 600 && window.innerWidth < 960;
  }

  get isMdScreen() {
    return window.innerWidth > 800;
  }

  get mySupplyChains(): any {
    return (supplyChain && supplyChain.my) || null;
  }

  get projectsModule() {
    return (
      this.userExist &&
      users.businessLicence.licence_definition.modules.find((m: any) => {
        return m.name === 'active_projects';
      })
    );
  }

  get userExist() {
    return this.$store.getters.userLoggedIn;
  }

  get hasBuyerLicence() {
    return users.businessLicence && users.businessLicence.licence_definition.name !== 'starter';
  }

  get showUpgrade() {
    return this.userExist && !this.hasBuyerLicence;
  }

  get legacyNav() {
    return !this.$store.state.newui.enabled || null;
  }

  get userName() {
    return this.$store.getters.currentUser ? this.$store.getters.currentUser.fullname : 'Profile';
  }

  get userEmail() {
    return this.$store.getters.currentUser ? this.$store.getters.currentUser.email : '';
  }

  get isBusinessUser() {
    return this.$store.getters.currentUser.user_type === 'user';
  }

  get userOrgId() {
    return this.$store.getters.userLoggedIn && this.$store.getters.currentUser
      ? this.$store.getters.currentUser.organization_id
      : null;
  }

  get orgName() {
    return this.$store.getters.userLoggedIn && this.$store.getters.currentUser
      ? this.$store.getters.currentUser.organization_name
      : '';
  }

  get routeFullPath() {
    return this.$route.fullPath;
  }

  private created() {
    this.$router.app.$on('routechanged', (data: any) => {
      this.setItems(data.to);
    });
    this.$router.onReady(() => {
      this.setItems();
    });
    if (this.$store.getters.currentUser && this.$route.path != '/supplier_search.html') {
      this.addDashboardItem();
      this.loadData();
    }
    this.$events.on('userLoggedIn', () => {
      this.addDashboardItem();
      this.loadData();
      // this.getId();
    });

    this.$events.on('my-projects-updated', () => {
      this.loadData();
    });
    this.$events.on('profile-updated', (data: any) => {
      if (data.section === 'profile') {
        this.addDashboardItem();
        this.loadData();
      }
    });
    // this.getId();
  }

  // getId() {
  //   getIdentityProfile().then((result: any) => {
  //       console.log("result", result);
  //     })
  // }

  private searchResult() {
    if (this.search && this.search.length > 0) {
      this.$router.push({ name: 'SearchResults', query: { search: this.search as string } });
    }
  }

  private addDashboardItem() {
    if (this.isBusinessUser) {
      const dashboardItemIndex = this.items.findIndex((e: any) => {
        return e.title === 'Dashboard';
      });
      if (dashboardItemIndex === -1) {
        this.items.splice(0, 0, this.dashboardItem);
      }
    }
  }

  private setItems(to?: Route) {
    const routemeta = to ? to.meta : this.$route.meta;
    if (routemeta.nav_item) {
      this.currentItem = this.items.find((item: any) => {
        return item.title.toLowerCase() === routemeta.nav_item.toLowerCase();
      });
      if (routemeta.child_nav_item) {
        this.currentChild = this.currentItem.children.find((item: any) => {
          return item.title.toLowerCase() === routemeta.child_nav_item.toLowerCase();
        });
        this.showChildMenu = true;
      } else {
        this.showChildMenu = false;
      }
    }
  }

  private async loadData() {
    if (!this.isBusinessUser) {
      this.setItems();
      this.loaded = true;
      return;
    }
    await supplyChain.loadMySupplyChains().then(() => {
      this.setProjectsList();

      supplyChain.loadAllSupplyChains().then((result: any) => {
        const registered_projects_count = result.filter((supplier: any) => {
          return supplier.registered === true;
        }).length;
        const own_projects_count = this.projectsList.filter((p: any) => {
          return p.status !== 'inactive';
        }).length;
        this.$events.fire('manual_data_update', {
          own_projects: own_projects_count,
          registered_projects: registered_projects_count,
        });
        this.setItems();
        this.loaded = true;
      });
      if (this.mySupplyChains && this.mySupplyChains.length > 0) {
        this.checkProjectInStore();
      } else {
        this.setNoProject();
      }
      this.$events.fire('supply-chain-loaded');
    });
  }

  private setProjectToStore(curProject: any) {
    const oldProjectId = this.curProject && this.curProject.projectId ? this.curProject.projectId : undefined;
    if (curProject) {
      this.curProject = _.cloneDeep(curProject);
      this.$store.commit('setCurrentProject', this.curProject);
      this.menu = false;
      if (this.$route.meta.on_project_change === 'reload') {
        this.$router.go(0);
      } else if (this.$route.meta.on_project_change || this.curProject.status === 'inactive') {
        let route_name = this.curProject.status === 'inactive' ? 'MarketRequests' : this.$route.meta.on_project_change
        this.$router.push({ name: route_name });
      }
      this.$forceUpdate();
    }
  }

  private checkProjectInStore() {
    if (
      this.$store.getters.currentProject &&
      this.$store.getters.currentProject.projectId !== null &&
      this.$store.getters.currentProject.projectId !== undefined
    ) {
      const curProject = this.projectsList.find((p: any) => {
        return p.projectId === this.$store.getters.currentProject.projectId;
      });
      if (curProject && curProject.organizationId === this.$store.getters.currentUser.organization_id) {
        this.curProject = curProject;
        this.$store.commit('setCurrentProject', this.curProject);
      } else {
        this.setFirstProjectByDefault();
      }
    } else {
      this.setFirstProjectByDefault();
    }
  }

  private setFirstProjectByDefault() {
    if (this.mySupplyChains && this.mySupplyChains.length > 0 && this.$store.getters.userLoggedIn) {
      const curProject = this.projectsList.find((p: any) => {
        return p.status !== 'inactive' && p.organizationId === this.$store.getters.currentUser.organization_id;
      });
      if (curProject) {
        this.curProject = curProject;
        this.$store.commit('setCurrentProject', this.curProject);
        this.$store.commit('setBuyer', true);
      } else {
        this.setNoProject();
      }
    } else {
      this.setNoProject();
    }
  }

  private setProjectsList() {
    this.projectsList = [];
    if (this.mySupplyChains && this.mySupplyChains.length > 0) {
      _.map(_.orderBy(this.mySupplyChains, ['name'.toLowerCase()], ['asc']), (project) => {
        const obj = {
          projectId: project.id,
          name: project.name,
          organizationId: project.organization_id,
          org: project.organization.trading_name,
          logo: project.logo,
          status: project.status,
          register_interest_package_id: project.register_interest_package_id,
          disabled: project.status === 'inactive' || project.organization_id !== this.userOrgId,
          class: '',
          created_at: project.created_at,
          updated_at: project.updated_at,
        };
        this.projectsList.push(obj);
        _.orderBy(project.sub_projects, ['name'], ['asc']).forEach((sval: any) => {
          this.projectsList.push({
            projectId: sval.id,
            name: sval.name,
            organizationId: sval.organization_id,
            org: sval.organization.trading_name,
            register_interest_package_id: sval.register_interest_package_id,
            logo: sval.logo,
            status: sval.status,
            disabled: sval.status === 'inactive',
            sub: true,
            class: 'ml-3',
            created_at: project.created_at,
            updated_at: project.updated_at,
          });
        });
      });
    }
  }

  private setNoProject() {
    this.curProject = null;
    this.$store.commit('setCurrentProject', {
      projectId: null,
      organizationId: null,
      register_interest_package_id: null,
    });
    this.$store.commit('setBuyer', false);
  }

  private goto(item: any) {
    this.currentItem = item;
    if (item && item.link) {
      if (item.external) {
        window.open(item.link);
      } else {
        this.currentChild = null;
        this.$router.push(item.link);
      }
    } else {
      this.showChildMenu = true;
    }
  }

  private goToChild(child: any) {
    this.currentChild = child;
    this.$router.push(child.link);
  }

  private showLoginDialog() {
    this.$store.commit('setUser', null);
    this.$router.push({ path: '/' });
  }

  private logout() {
    this.setNoProject();
    this.$store.commit('setRefreshToken', false);
    users.logout(this.$store.getters.currentUser.id).then((res: any) => {
      this.$events.fire('userLoggedOut');
      this.items.splice(0, 1);
      this.showLoginDialog();
    });
  }

  private trucatedText(text: string, length: number) {
    return text && text.length > length ? text.substring(0, length) + '...' : text;
  }

  get avatar() {
    return require('@/assets/samples/sample_profile-photo-1_500x500.jpg')//this.$store.getters.currentUser.avatar ? require('@/assets/user-circle-solid_grey.png') : false;
  }

  private data() {
    return {
      drawer: true,
      mini: false,
      right: null,
      helpers: Helpers,
      on: null,
      showMenu: false
    };
  }
}
